import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import { IExtraOption, IStoreState, CUSTOM } from '../../utils'
import { ChangeEventType } from '../TextArea'
import { TextField } from '@material-ui/core'
import { customSeparatorChanged } from '../../actions'

export interface IButtonProps extends IExtraOption {
  active: boolean
  onChange(kind: string, value: string): void
}

interface IActiveCustomContentProps {
  title: string
  value: string
  onChange(value: string): void
}

const ActiveCustomContent = (props: IActiveCustomContentProps) => {
  const inputStyle = { width: 30, padding: 0 }
  const textFieldStyle = { marginLeft: 5 }

  const { value, title, onChange } = props

  const handleChange = (event: ChangeEventType) => {
    const newValue = event.target.value
    onChange(newValue)
  }

  // using TextField straight from Material UI - as Picasso version doesn't support autoFocus
  return (
    <React.Fragment>
      {title}:
      <TextField
        autoFocus={true}
        value={value}
        inputProps={{ style: inputStyle }}
        style={textFieldStyle}
        onChange={handleChange}
      />
    </React.Fragment>
  )
}

const mapStateToProps = (state: IStoreState) => ({
  value: state.customSeparator
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: (value: string) => {
    dispatch(customSeparatorChanged(value))
  }
})

const ActiveCustomContentSmart = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActiveCustomContent)

export const ButtonContent = (props: IButtonProps) => {
  const { active, kind, title } = props
  if (kind === CUSTOM.kind && active) {
    return <ActiveCustomContentSmart title={title} />
  } else {
    return <React.Fragment>{title}</React.Fragment>
  }
}
